@if (isPopupOpen) {
  <div class="bm--bg-popup" (click)="closePopup()">
    <div class="info-popup__information" (click)="$event.stopPropagation()">
      <div class="info-popup__header">
        <p class="info-popup__title">Start Selling</p>
        <div class="btv-icon-close" (click)="closePopup()"></div>
      </div>
      <div class="info-popup__footer">
        <p class="info-popup__text">
          Start selling now! <br />
          Switch your account to <b>Seller's Account</b>.
        </p>
      </div>
      <form class="start-selling" [formGroup]="createBeatmakerAccountForm" (ngSubmit)="onSubmit()">
        <bmcore-input formControlName="nickname" [title]="'Nickname'" [type]="'text'" [controlFormName]="'nickname'">
        </bmcore-input>
        <!-- Input checkbox: must to check -->
        <div class="start-selling__wrapper">
          <input class="custom-input" id="termsConditions" type="checkbox" formControlName="acceptTerms" />
          <label for="termsConditions" class="start-selling__label"></label>
          <p>
            I have read and accept the
            <a target="_blank" routerLink="/user-agreement">terms and conditions</a>
          </p>
        </div>
        <div class="start-selling__btn">
          <bmcore-button
            title="Get Started"
            styleName="right"
            [disabled]="createBeatmakerAccountForm.invalid || !createBeatmakerAccountForm.value.acceptTerms"
          >
          </bmcore-button>
        </div>
      </form>
    </div>
  </div>
}
